import React, { useEffect, useState } from "react";
import { fetchDataGet } from "../../controler/comunicacao";
import "./rodapeDados.css";

// Rodapé com a data dos dados carregados pela API.
//
// A data vem de /api/dados-atualizados, e NÃO de /api/status-atualizacao. Os
// dois parecem intercambiáveis e não são: o de status reporta a última
// EXECUÇÃO do pipeline, inclusive quando ela falha. Se a atualização do dia 25
// falhar, aquele endpoint passa a devolver a data da falha — e o rodapé
// anunciaria dados novos que não existem. O endpoint usado aqui reporta o
// arquivo que está de fato em memória.
//
// Sem React Query de propósito: o cache do app é persistido em localStorage
// por 24 h, e um indicador de "quão atual é o dado" exibindo valor velho por
// um dia inteiro seria pior do que não existir.

const FONTES = "SINAN · IBGE · IPEA · CNES";

function formatarData(iso) {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

function RodapeDados() {
  const [data, setData] = useState(null);

  useEffect(() => {
    let ativo = true;
    fetchDataGet("/api/dados-atualizados")
      .then((resposta) => {
        if (ativo && resposta && resposta.atualizado_em) {
          setData(formatarData(resposta.atualizado_em));
        }
      })
      .catch(() => {
        // fetchDataGet já registra no console. O rodapé é informativo: se a
        // data não vier, ele some em vez de exibir "Invalid Date" ou um traço
        // solto, que passariam a impressão de dado quebrado.
      });
    return () => {
      ativo = false;
    };
  }, []);

  if (!data) return null;

  return (
    <footer className="rodape-dados">
      <span className="rodape-dados__texto">
        Dados atualizados em <strong>{data}</strong>
        <span className="rodape-dados__separador"> — </span>
        <span className="rodape-dados__fontes">{FONTES}</span>
      </span>
    </footer>
  );
}

export default RodapeDados;
